module.exports = __webpack_public_path__ + "img/INTERIOR-IGNIS-2021-3.2310ad33.jpg";